// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__23e5m","left":"InfoRow_left__1K5DS"};